export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="38" viewBox="0 0 25 38" fill="none">
            <path d="M23.38 36.9585L1.38001 0.958531" stroke="#FF8000" strokeWidth="2" />
        </svg>
    );
}
